<div class="firma-wizard-inline-host">
  <app-configuracion-firmas-tipo-firmantes
    #wizard
    [firmante]="firmante"
    [inlineMode]="true">
  </app-configuracion-firmas-tipo-firmantes>
</div>
